var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.clickLetter(_vm.letter)}}},[_vm._v("\n  "+_vm._s(_vm.letter)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }